import { render, staticRenderFns } from "./milestone_item.vue?vue&type=template&id=52842b6b"
import script from "./milestone_item.vue?vue&type=script&lang=js"
export * from "./milestone_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports